import browser from "@raiden/library/constants/browser";
import { COOKIES_NAME_VALUE_ACCEPT_COOKIES } from "@raiden/library/constants/cookies";
import getBasePath from "@splitfire-agency/raiden-library/dist/libraries/utils/getBasePath";
import cookie from "cookie";
import { AnimatePresence } from "framer-motion";
import { Router } from "next/router";
import { memo, useCallback, useEffect, useState } from "react";
import {
  getGoogleAnalyticsScript,
  getGoogleTagManagerScript,
  trackPageView,
} from "../../helpers/googleTracking";
import CookiesModal from "./CookiesModal";

const GOOGLE_ANALYTICS_KEY = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_KEY;

const GOOGLE_TAG_MANAGER_KEY = process.env.NEXT_PUBLIC_TAG_MANAGER_KEY;

/**
 * @param {object} params
 * @param {Record<string, any>} params.cookies
 */
function CookiesConsent({ cookies }) {
  const [cookiesState, setCookiesState] = useState(
    /** @type {"0" | "1" | null} */
    (cookies[COOKIES_NAME_VALUE_ACCEPT_COOKIES] ?? null),
  );

  const [isClosedByUser, setIsClosedByUser] = useState(false);

  const handleAccept = useCallback(() => {
    setCookiesState("1");
    if (browser) {
      document.cookie = cookie.serialize(
        COOKIES_NAME_VALUE_ACCEPT_COOKIES,
        "1",
        {
          path: getBasePath(process.env.NEXT_PUBLIC_FRONT_BASE_PATH ?? ""),
          secure: true,
        },
      );
    }
  }, []);

  const handleRefuse = useCallback(() => {
    setCookiesState("0");
    if (browser) {
      document.cookie = cookie.serialize(
        COOKIES_NAME_VALUE_ACCEPT_COOKIES,
        "0",
        {
          path: getBasePath(process.env.NEXT_PUBLIC_FRONT_BASE_PATH ?? ""),
          secure: true,
        },
      );
    }
  }, []);

  const handleClose = useCallback(() => {
    setIsClosedByUser(true);
  }, []);

  useEffect(() => {
    if (
      (GOOGLE_ANALYTICS_KEY || GOOGLE_TAG_MANAGER_KEY) &&
      cookiesState === "1"
    ) {
      Router.events.on("routeChangeComplete", (path) => {
        trackPageView(
          window.location.pathname + window.location.search,
          GOOGLE_ANALYTICS_KEY || GOOGLE_TAG_MANAGER_KEY,
        );
      });
    }
  }, [cookiesState]);

  return (
    <>
      {GOOGLE_TAG_MANAGER_KEY &&
        cookiesState === "1" &&
        getGoogleTagManagerScript(GOOGLE_TAG_MANAGER_KEY)}

      {GOOGLE_ANALYTICS_KEY &&
        cookiesState === "1" &&
        getGoogleAnalyticsScript(GOOGLE_ANALYTICS_KEY)}

      <AnimatePresence>
        {cookiesState === null && !isClosedByUser && (
          <CookiesModal
            accept={handleAccept}
            refuse={handleRefuse}
            close={handleClose}
          />
        )}
      </AnimatePresence>
    </>
  );
}

export default memo(CookiesConsent);
